import React, { useState, useEffect, useCallback } from "react";
import { MultiSelect } from "react-multi-select-component";
// import TimePicker from "react-time-picker";
import "./Addattendance.css";
import { addattendance, FetchEmployee } from "../../../Config/api";
import { toast } from "react-toastify";
import DateselectComp from "../../Component/DateMutipleselect";
import { getRegisterId } from "../../../Config/userId";
import { getUserDetails } from "../../../Services/Storage";
import CustomTimePicker from "../../Component/TimePickerInput";

const Addattendance = ({ show, close, sendDataToParent }) => {
  const register_id = getRegisterId();
  const userDetails = getUserDetails();
  const accessid =
    userDetails?.get_access_role?.[0]?.invite_user_details?.[0]?.register || "";
  const [employees, setEmployees] = useState([]);
  const [fromvalue, Setfromtime] = useState(null);
  const [tovalue, Settotime] = useState(null);
  const [errors, setErrors] = useState({});
  const [isFullDay, setIsFullDay] = useState(false);
  const [loading, setloading] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);

  const [formData, setFormData] = useState({
    register_id: [],
    punch_in_time: "",
    punch_out_time: "",
    select_time: " ",
  });

  const fetchEmployeeList = useCallback(async () => {
    try {
      const response = await FetchEmployee(
        `?register_id=${register_id}&access_id=${accessid}`
      );
      setEmployees(response.data.emp_name_id);
    } catch (error) {}
  }, [register_id, accessid]);

  useEffect(() => {
    fetchEmployeeList();
  }, [fetchEmployeeList]);

  const handleMultiSelectChange = (selected) => {
    setErrors({});

    const values = Array.from(selected, (option) => option.value);
    setFormData((state) => ({
      ...state,
      register_id: values,
    }));
  };

  const closePopUp = () => {
    close();
    setFormData({
      register_id: [],
      punch_in_time: "",
      punch_out_time: "",
      select_time: " ",
    });
    setIsFullDay(false);
    Setfromtime(null);
    Settotime(null);
    setErrors({});
    setSelectedDates([]);
  };
  // const handlefromtimechange = (time) => {
  //   setErrors({});

  //   if (!time) return;
  //   Setfromtime(time);
  //   setFormData((state) => ({
  //     ...state,
  //     punch_in_time: time + ":00",
  //   }));
  // };

  // const handletotimechange = (time) => {
  //   setErrors({});

  //   if (!time) return;
  //   Settotime(time);
  //   setFormData((state) => ({
  //     ...state,
  //     punch_out_time: time + ":00",
  //   }));
  // };

  const handleCheckboxChange = () => {
    setErrors({});

    setIsFullDay(!isFullDay);
    setFormData((state) => ({
      ...state,
      select_time: !isFullDay ? "fullday" : "",
    }));
  };

  const handleSubmit = async () => {
    const newErrors = {};

    if (formData.register_id.length === 0) {
      newErrors.register_id = "Select Employee is required";
    }
    // if (selectedDates.length < 0) {
    //   newErrors.date = 'Please select a date.';
    // }
    if (selectedDates.length === 0) {
      // Validate selected dates
      newErrors.date = "Please select a date.";
    }
    if (!isFullDay && formData.punch_in_time.trim() === "") {
      newErrors.punch_in_time = "Punch In is required";
    }
    if (!isFullDay && formData.punch_out_time.trim() === "") {
      newErrors.punch_out_time = "Punch Out is required";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      try {
        setloading(true);
        const data = {
          ...formData,
          date: selectedDates,

          ...(isFullDay && { punch_in_time: "", punch_out_time: "" }),
        };
        const response = await addattendance(data);
        if (response) {
          sendDataToParent(response.get_attendance);
          close();
          toast.success("Attendance added successfully!", {
            position: "top-center",
            autoClose: 2000,
            closeButton: false,
          });
          setFormData({
            register_id: [],
            date: "",
            punch_in_time: "",
            punch_out_time: "",
            select_time: " ",
          });
          Setfromtime(null);
          Settotime(null);
          setIsFullDay(false);
        }
      } catch (error) {
        if (error.response) {
          const newErrors = {};
          newErrors.response_error = error.response.data.data;
          setErrors(newErrors);
        } else {
          toast.error("Failed. Please try again.", {
            position: "top-center",
            autoClose: 2000,
            closeButton: false,
          });
          const newErrors = {
            response_error: [],
          };
          for (const key in error.response.data.errors) {
            if (error.response.data.errors.hasOwnProperty(key)) {
              newErrors.response_error.push(
                `${error.response.data.errors[key]}`
              );
            }
          }
          setErrors(newErrors);
          setFormData((state) => ({
            ...state,
          }));
        }
      } finally {
        setloading(false);
      }
    }
  };

  if (!show) return null;

  return (
    <div className="addatten-main">
      <div className="addatten-main-sub">
        <div className="addatten-container">
          <span className="uploadexcel-close" onClick={closePopUp}>
            &times;
          </span>

          <div className="addatten-heading">
            <p>Add Attendance</p>
          </div>
          <div className="addatten-strightline"></div>
          <div className="addatten-inputfield">
            <div className="addatten-sub">
              <div className="addatten-input">
                <div className="addatten-input-sub">
                  <div className="addatten-inputfield">
                    <label>Employee Name</label>
                    <div style={{ width: "180px" }}>
                      <MultiSelect
                        options={employees.map((emp) => ({
                          label: `${emp.name} - ${emp.employee_id}`,
                          value: emp.register_id,
                        }))}
                        value={formData.register_id.map((id) => ({
                          label: employees.find((emp) => emp.register_id === id)
                            ?.name,
                          value: id,
                        }))}
                        onChange={handleMultiSelectChange}
                        overrideStrings={{
                          allItemsAreSelected: "All employees selected",
                          selectSomeItems: "Select Employees",
                        }}
                      />
                    </div>
                    {errors.register_id && (
                      <div className="error-message-view">
                        {errors.register_id}
                      </div>
                    )}
                  </div>
                  <div className="addatten-inputfield">
                    <label>Date</label>
                    <div className="addatten-inputdate-style">
                      <DateselectComp setSelectedDates={setSelectedDates} />
                    </div>
                    {errors.date && (
                      <div className="error-message-view">{errors.date}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="addatten-checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={isFullDay}
                    onChange={handleCheckboxChange}
                  />
                  Full day
                </label>
              </div>
              {!isFullDay && (
                <div className="addatten-input-sub">
                  <div className="addatten-inputfield">
                    <label>Punch In</label>
                    <div>
                      <CustomTimePicker
                        value={fromvalue}
                        onChange={(val) => {
                          Setfromtime(val);
                          setFormData((state) => ({
                            ...state,
                            punch_in_time: val,
                          }));
                        }}
                      />
                    </div>
                    {errors.punch_in_time && (
                      <div className="error-message-view">
                        {errors.punch_in_time}
                      </div>
                    )}
                  </div>
                  <div className="addatten-inputfield">
                    <label>Punch Out</label>
                    <div>
                      <CustomTimePicker
                        value={tovalue}
                        onChange={(val) => {
                          Settotime(val);
                          setFormData((state) => ({
                            ...state,
                            punch_out_time: val,
                          }));
                        }}
                      />
                    </div>
                    {errors.punch_out_time && (
                      <div className="error-message-view">
                        {errors.punch_out_time}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="response-message-view">
                {errors.response_error && (
                  <div className="error-message-view">
                    {errors.response_error}
                  </div>
                )}
              </div>

              <div className="button-addattend">
                <button onClick={handleSubmit} disabled={loading}>
                  {loading ? <span className="spinner"></span> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addattendance;
